import type { IconSvgObject } from './types';

const ReceiptRussianRubleIcon: IconSvgObject = [
  ["path", { d: "M9.5 2L12 3.5L14.5 2L17 3.5L20 2V22L17 20.5L14.5 22L12 20.5L9.5 22L7 20.5L4 22V2L7 3.5L9.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.4999 11.5V8.5C10.4999 7.94772 10.9477 7.5 11.4999 7.5H13.4999C14.6045 7.5 15.4999 8.39543 15.4999 9.5C15.4999 10.6046 14.6045 11.5 13.4999 11.5H10.4999ZM10.4999 11.5V14.5M10.4999 11.5H8.49994M10.4999 14.5V16.5M10.4999 14.5H8.49994M10.4999 14.5H13.4999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ReceiptRussianRubleIcon;
